import { inject, Pipe, PipeTransform, Renderer2 } from '@angular/core';

@Pipe({
  name: 'zCssVarToNumber',
  standalone: true,
})
export class CssVarToNumberPipe implements PipeTransform {
  private readonly _renderer = inject(Renderer2);

  transform(varName: string, fallback = 0) {
    if (!varName) return fallback;

    try {
      const testEl = this._renderer.createElement('div');
      this._renderer.setStyle(testEl, 'width', `var(${varName}, ${fallback})`);
      this._renderer.setStyle(testEl, 'visibility', 'hidden');
      this._renderer.appendChild(document.body, testEl);
      const value = getComputedStyle(testEl).width;
      this._renderer.removeChild(document.body, testEl);
      return parseInt(value, 10) || fallback;
    } catch (err) {
      console.warn(`Error reading CSS variable: ${varName}`, err);
      return fallback;
    }
  }
}
